import { views } from './views';

export const fastPeriodNames = {
  ago: 'ago',
  last: 'last',
  current: 'current',
  next: 'next',
  ahead: 'ahead',
};

export const period = {
  [views.day]: 'день',
  [views.week]: 'неделю',
  [views.month]: 'месяц',
};

export const fastPeriodTexts = {
  [fastPeriodNames.ago]: {
    [views.day]: '2 дня',
    [views.week]: '2 недели',
    [views.month]: '2 месяца',
  },
  [fastPeriodNames.last]: {
    [views.day]: 'Вчера',
    [views.week]: 'Прошлая',
    [views.month]: 'Прошлый',
  },
  [fastPeriodNames.current]: {
    [views.day]: 'Сегодня',
    [views.week]: 'Текущая',
    [views.month]: 'Текущий',
  },
  [fastPeriodNames.next]: {
    [views.day]: 'Завтра',
    [views.week]: 'Будущая',
    [views.month]: 'Будущий',
  },
  [fastPeriodNames.ahead]: {
    [views.day]: '2 дня',
    [views.week]: '2 недели',
    [views.month]: '2 месяца',
  },
};
